import DefaultBackground from './DefaultBackground';

export default DefaultBackground;
